import { Item } from "..";
import { DesignPriceCalculatorRuleBased } from "../../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased";
import { Integration, PlatformAttributeSelection } from "./Integration";

enum MessageType {
    Close = "Close"
}

export default class MerchantIntegrationPreview implements Integration {

    private pricingCalculator: DesignPriceCalculatorRuleBased | null = null;

    public constructor() {

    }

    addToCart(composition: any, design: any, model: any, attributes: PlatformAttributeSelection[], designItems: Item[], quantity: number, additionalProperties: Record<string, any>) {
        // Not implemented
    }

    getPrice(composition: any, design: any, model: any, attributes: any, compositionPrice: any, isCustomPricingConfiguratorEnabled: any, isCustomPricingRuleBasedEnabled: any, quantity: number): Promise<{ price: number, isOutOfStock: boolean }> {
        return new Promise<{ price: number, isOutOfStock: boolean }>((resolve, reject) => {
            console.log('[preview.getPrice] Calculating price...');

            let designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
            if (!isCustomPricingRuleBasedEnabled) designPrice = 0;
            if (designPrice !== 0 && quantity > 1) designPrice = designPrice / quantity;

            let normalizedCompositionPrice = isCustomPricingConfiguratorEnabled ? compositionPrice : 0;
            if (normalizedCompositionPrice !== 0 && quantity > 1) normalizedCompositionPrice = normalizedCompositionPrice / quantity;

            console.log('[preview.getPrice] Calculated Zakeke price:');
            console.log('- Composition price: ' + normalizedCompositionPrice);
            console.log('- Design price: ' + designPrice);

            resolve({
                price: normalizedCompositionPrice + designPrice,
                isOutOfStock: false
            });
        });
    }

    getSharedCompositionUrl(compositionDocID: string) {

        return new Promise<{ url: string }>((resolve, reject) => {

        });
    }

    setPricingCalculator(pricingCalculator: DesignPriceCalculatorRuleBased) {
        this.pricingCalculator = pricingCalculator;
    }

    close() {
        window.parent.postMessage({
            zakekeMessageType: MessageType.Close,
        }, '*');
    }
}
